import React from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import RegisterHook from "../../hook/auth/register-hook";
import { ToastContainer } from "react-toastify";
import ValidTORMessages from "./ValidMessages/ValidMessages";
import validatePassword from "../../Feature/PassworValidRegex";
import { validateEmail } from "../../Feature/EmailValidRegex";
import { validateEgyptianPhoneNumber } from "../../Feature/PhoneValidRegex";
import { validateName } from "../../Feature/NameValidRegex";
const RegisterPage = () => {
  const [
    name,
    email,
    phone,
    password,
    confirmPassword,
    loading,
    onChangeName,
    onChangeEmail,
    onChangePhone,
    onChangePassword,
    onChangeConfirmPassword,
    OnSubmit,
    isPress,
    rememberMe,
    onChangeRememberMe,
    isComplate,
    showPassword,
    showPasswordConfirm,
    togglePasswordVisibility,
    togglePasswordConFirmVisibility,
  ] = RegisterHook();
  const handleKeyUp = (e) => {
    if (e.code === "Enter" && isComplate) {
      OnSubmit();
    }
  };
  return (
    <Container
      className="shadow my-4"
      style={{ minHeight: "690px", width: "375px" }}
    >
      <Row className="py-5 d-flex justify-content-center">
        <Col sm="12" className="d-flex flex-column ">
          <label className="title-login">تسجيل حساب جديد</label>
          <div class="input-group my-2 d-flex align-items-center justify-content-center w-100 rounded shadow-sm p-1 bg-white">
            <div
              class=" h-100 bg-white input-group-text input-group-prepend "
              id="basic-addon1"
              style={{
                border: "none",
                outline: "none",
                borderRadius: "0",
              }}
            >
              <i class="fas fa-user"></i>
            </div>
            <input
              value={name}
              onChange={onChangeName}
              placeholder="اسم المستخدم..."
              type="email"
              className="user-input"
              onKeyUp={handleKeyUp}
              style={{
                flex: "1",
                border: "none",
                outline: "none",
                borderRadius: "0",
              }}
            />
          </div>

          {name.length > 1 ? (
            <ValidTORMessages validlistError={validateName(name)} />
          ) : null}
          <div class="input-group my-2 d-flex align-items-center justify-content-center w-100 rounded shadow-sm p-1 bg-white">
            <div
              class=" h-100 bg-white input-group-text input-group-prepend "
              id="basic-addon1"
              style={{
                border: "none",
                outline: "none",
                borderRadius: "0",
              }}
            >
              <i class="fas fa-at"></i>
            </div>
            <input
              value={email}
              onChange={onChangeEmail}
              placeholder="الايميل..."
              type="email"
              className="user-input"
              onKeyUp={handleKeyUp}
              style={{
                flex: "1",
                border: "none",
                outline: "none",
                borderRadius: "0",
              }}
            />
          </div>

          {email.length > 1 ? (
            <ValidTORMessages validlistError={validateEmail(email)} />
          ) : null}
          <div class="input-group my-2 d-flex align-items-center justify-content-center w-100 rounded shadow-sm p-1 bg-white">
            <div
              class=" h-100 bg-white input-group-text input-group-prepend "
              id="basic-addon1"
              style={{
                border: "none",
                outline: "none",
                borderRadius: "0",
              }}
            >
              <i class="fas fa-phone"></i>
            </div>
            <input
              value={phone}
              onChange={onChangePhone}
              placeholder="الهاتف..."
              type="phone"
              className="user-input"
              onKeyUp={handleKeyUp}
              style={{
                flex: "1",
                border: "none",
                outline: "none",
                borderRadius: "0",
              }}
            />
          </div>

          {phone.length > 1 ? (
            <ValidTORMessages
              validlistError={validateEgyptianPhoneNumber(phone)}
            />
          ) : null}
          <div class="input-group my-2 d-flex align-items-center justify-content-center w-100 rounded shadow-sm p-1 bg-white">
            <div
              class=" h-100 bg-white input-group-text input-group-prepend "
              id="basic-addon1"
              style={{
                border: "none",
                outline: "none",
                borderRadius: "0",
              }}
            >
              <i class="fas fa-lock"></i>
            </div>
            <input
              value={password}
              onChange={onChangePassword}
              placeholder="كلمه السر..."
              type={showPassword ? "text" : "password"}
              onKeyUp={handleKeyUp}
              className="user-input"
              style={{
                flex: "1",
                border: "none",
                outline: "none",
                borderRadius: "0",
              }}
            />
            <button
              className="bg-white"
              type="button"
              style={{
                border: "none",
                outline: "none",
                borderRadius: "0",
              }}
              onClick={togglePasswordVisibility}
            >
              {showPassword ? (
                <i className="fa fa-eye-slash"></i> // Hide password icon
              ) : (
                <i className="fa fa-eye"></i> // Show password icon
              )}
            </button>
          </div>
          {password.length > 1 ? (
            <ValidTORMessages validlistError={validatePassword(password)} />
          ) : null}
          <div class="input-group my-2 d-flex align-items-center justify-content-center w-100 rounded shadow-sm p-1 bg-white">
            <div
              class=" h-100 bg-white input-group-text input-group-prepend "
              id="basic-addon1"
              style={{
                border: "none",
                outline: "none",
                borderRadius: "0",
              }}
            >
              <i class="fas fa-lock"></i>
            </div>
            <input
              value={confirmPassword}
              onChange={onChangeConfirmPassword}
              placeholder="تأكيد كلمه السر..."
              type={showPasswordConfirm ? "text" : "password"}
              onKeyUp={handleKeyUp}
              className="user-input"
              style={{
                flex: "1",
                border: "none",
                outline: "none",
                borderRadius: "0",
              }}
            />
            <button
              className="bg-white"
              type="button"
              style={{
                border: "none",
                outline: "none",
                borderRadius: "0",
              }}
              onClick={togglePasswordConFirmVisibility}
            >
              {showPasswordConfirm ? (
                <i className="fa fa-eye-slash"></i> // Hide password icon
              ) : (
                <i className="fa fa-eye"></i> // Show password icon
              )}
            </button>
          </div>
          {confirmPassword.length > 1 ? (
            <ValidTORMessages validlistError={validatePassword(password)} />
          ) : null}
          <div className="d-flex justify-content-start align-items-center my-3">
            <input
              value={rememberMe}
              onChange={onChangeRememberMe}
              type="checkbox"
              className="form-check-input"
              style={{ marginLeft: "5px" }}
            />
            <h3 className="fs-6 mr-2">تذكرنى</h3>
          </div>
          {isComplate ? (
            <button onClick={OnSubmit} className="btn-login">
              تسجيل الدخول
            </button>
          ) : (
            <button disabled className="bg-grey-500 btn">
              تسجيل الدخول
            </button>
          )}
          {isPress === true ? (
            loading === true ? (
              <Spinner animation="border" role="status"></Spinner>
            ) : null
          ) : null}
          <label className="my-4">
            لديك حساب بالفعل؟{" "}
            <Link to="/login" style={{ textDecoration: "none" }}>
              <span style={{ cursor: "pointer" }} className="text-danger">
                اضغط هنا
              </span>
            </Link>
          </label>
        </Col>
      </Row>
      <ToastContainer />
    </Container>
  );
};

export default RegisterPage;
